import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

export default function PayPayButton({ onClick, disabled }) {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={(theme) => ({
        width: "100%",
        padding: "8px",
        borderRadius: "27px",
        border: `2px solid white`,
        height: "54px",
        background: "transparent",
        "&:hover": {
          opacity: 0.9, // ホバー時の軽いエフェクト
        },
      })}
      onClick={onClick}
    >
      {/* url(/paypay_logo.png)を使用する */}
      <img src={"/paypay_logo_white.png"} alt="PayPay" style={{ height: 44 }} />
    </Button>
  );
}
